import { createSlice } from "@reduxjs/toolkit";

interface ChapterSelection {
  moduleId: string | null;
  chapterId: string | null;
}

interface previewDataType {
  surveyId: string;
  parentId: string;
  isSubmitted: boolean;
}

interface SurveyState {
  data: previewDataType;
}

const initialState: SurveyState = {
  data: {
    surveyId: "",
    parentId: "",
    isSubmitted: false
  }
};

export const SurveySlice = createSlice({
  name: "SurveySlice",
  initialState,
  reducers: {
    setSurveyData(state, action) {
      state.data = action.payload;
    }
  }
});

export default SurveySlice;
export const SurveySliceActions = SurveySlice.actions;
